; (function ($) {
    $.fn.tabs = function (options) {
        var defaults = {
        }

        if (this.length == 0) return this;

        // support mutltiple elements
        if (this.length > 1) {
            this.each(function () { $(this).tabs(options) });
            return this;
        }
        var el = this;

        var tabs = {};

        var init = function () {
            tabs.settings = $.extend({}, defaults, options);
            if ($(el).children('.control').hasClass('on')) {
                var on = $(el).children('.on').index();
                $(el).next('.tab__content').children('.target').eq(on);
                $(el).next('.tab__content').children('.target').eq(on).fadeIn(300).siblings().hide();
            } else {
                $(el).children('.control').eq(0).addClass('on');
                var on = $(el).children('.control').eq(0).index();
                $(el).next('.tab__content').children('.target').eq(on);
                $(el).next('.tab__content').children('.target').eq(on).fadeIn(300).siblings().hide();
            }
        };

        var start = function () {
            init();
            $(el).children('.control').on('click', function (e) {
                $(this).addClass('on default').siblings().removeClass('on default');
                var on = $(el).children('.on').index();
                $(el).next('.tab__content').children('.target').eq(on).fadeIn(300).siblings().hide();
                $('[data-slick-slider="pattern"]').slick("setPosition");
            });
        };

        start();
        return this
    };
})(jQuery);